import PropTypes from "prop-types"; // Import PropTypes
import { Button, Container } from "react-bootstrap";

const BenefitsList = ({ benefits, developer }) => {
  return (
    <section className="benefits-section">
      <Container fluid className="p-4 p-lg-5">
        <h2 className="text-primary mb-0 text-uppercase ft-wt-600 mb-4">
          {/* Benefits of hiring {developer} developers */}
          Why Choose A {developer} Developer From Acube?
        </h2>
        <ul className="list-block">
          {benefits?.map((benefit, index) => (
            <li className="text-primary" key={index}>
              <p className="mb-0">{benefit}</p>
            </li>
          ))}
        </ul>
      </Container>
    </section>
  );
};

BenefitsList.propTypes = {
  benefits: PropTypes.arrayOf(PropTypes.string).isRequired, // Array of strings
  developer: PropTypes.string.isRequired, // String type
};

export default BenefitsList;
